
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.3 4.8v1.175H5.7V4.8a2.8 2.8 0 115.6 0zM.5 9.975a4.001 4.001 0 013.2-3.92V4.8a4.8 4.8 0 119.6 0v1.255a4.001 4.001 0 013.2 3.92v6.4a4 4 0 01-4 4h-8a4 4 0 01-4-4v-6.4zm9.6 2.2a1.6 1.6 0 01-.799 1.385v1.195a.8.8 0 01-1.6 0v-1.193a1.6 1.6 0 112.399-1.387z","fill":"#ABAFB5"}})])
          )
        }
      }
    